import React from 'react';

import Button from '../../library/button/button';

import { trackAction } from '../../shared/utils/analytics/analytics';
import {
  ProductProp,
  ProductTypeProp
} from '../../shared/utils/prop-types/prop-types';

import { PRODUCT_TYPES } from '../../shared/constants/products';

import styles from './shop-replacement-button.scss';

function getShopButtonLabel(productType, product, replacementBrand) {
  let brand = '';
  let suffix = '';

  if (product?.isReplacementBrandHasProduct) {
    if (replacementBrand) {
      brand = replacementBrand?.name;
    } else {
      brand = product?.brand;
    }
  }

  if (productType === PRODUCT_TYPES.WHEELS) {
    if (product?.wheelRimDiameter) {
      suffix = `${product?.wheelRimDiameter} inch`;
    }
  }

  if (!suffix && !brand) {
    brand = product?.brand;
  }

  return `Shop ${brand}${
    brand && suffix ? ` - ${suffix}` : suffix
  } ${productType}`;
}

function trackShopClick(productType, product) {
  const type = productType?.slice(0, -1)?.toLowerCase();

  trackAction(
    `product_detail_nla_shop_${type}`,
    productType === PRODUCT_TYPES.WHEELS
      ? { wheel_brand: product?.brand, wheel_size: product?.wheelRimDiameter }
      : {}
  );
}

function ShopReplacementButton(props) {
  const { product, productType } = props;

  if (!product?.replacementUrl) return null;

  return (
    <div className="shop-replacement-button">
      <Button
        className={styles['shop-button']}
        href={product?.replacementUrl}
        isPrimary
        onClick={() => trackShopClick(productType, product)}
      >
        {getShopButtonLabel(
          productType,
          product,
          product?.brandReferences?.[0]?.target
        )}
      </Button>
    </div>
  );
}

ShopReplacementButton.propTypes = {
  product: ProductProp,
  productType: ProductTypeProp
};

export default ShopReplacementButton;
